import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get, isBoolean } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";

const mapBooleanToYesNo = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  return "-";
};

const FireDetectorSystemView = ({
  fireProtection,
  isExpandable = true,
  t,
  isTracking,
}) => {
  const {
    location,
    isConfiguredInIBMS,
    isInstalledInTenantArea,
    isIntegratedWithTenantAccessControl,
    isIntegratedWithMainSystem,
    isIntegratedWithBuildingSystem,
    isIntegratedWithCommandCenter,
  } = fireProtection;

  const fields = useMemo(
    () => [
      {
        name: "Location of Main Fire detection & alarm system of building",
        key: "location",
        isRequired: true,
        isVisible: isTracking ? !!location : true,
      },
      {
        name: "Is Main Fire detection & alarm system of building is configured in IBMS",
        key: "isConfiguredInIBMS",
        isRequired: true,
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking ? isBoolean(isConfiguredInIBMS) : true,
      },
      {
        name: "Is Fire detection & alarm system installed in all tenant’s area",
        key: "isInstalledInTenantArea",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking ? isBoolean(isInstalledInTenantArea) : true,
      },
      {
        name: "Is Fire detection & alarm system of all tenants is integrated with access control system of tenant area",
        key: "isIntegratedWithTenantAccessControl",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking
          ? isBoolean(isIntegratedWithTenantAccessControl)
          : true,
      },
      {
        name: "Is Fire detection & alarm system of all tenants is integrated with main Fire detection & alarm system of building",
        key: "isIntegratedWithMainSystem",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking ? isBoolean(isIntegratedWithMainSystem) : true,
      },
      {
        name: "Is Main Fire detection & alarm system of building integrated with access control system, Lifts, HVAC system, PA system, Fire pumps, Flow switches etc of building",
        key: "isIntegratedWithBuildingSystem",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking
          ? isBoolean(isIntegratedWithBuildingSystem)
          : true,
      },
      {
        name: "Is Main Fire detection & alarm system panel of building is integrated with GIFT City command & control center",
        key: "isIntegratedWithCommandCenter",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking ? isBoolean(isIntegratedWithCommandCenter) : true,
      },
    ],
    [
      location,
      isConfiguredInIBMS,
      isInstalledInTenantArea,
      isIntegratedWithTenantAccessControl,
      isIntegratedWithMainSystem,
      isIntegratedWithBuildingSystem,
      isIntegratedWithCommandCenter,
    ]
  );

  const isCollapseVisible = useMemo(
    () => fields.some(({ isVisible }) => isVisible),
    [fields]
  );

  return (
    <>
      {isCollapseVisible && (
        <Collapse title="Fire Detector System" isExpandable={isExpandable}>
          <Row className="d-flex mb-2">
            {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
              const value = get(fireProtection, key, "");
              if (typeof isVisible !== "boolean" || isVisible) {
                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(fireProtection, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              }
            })}
          </Row>
        </Collapse>
      )}
    </>
  );
};

FireDetectorSystemView.propTypes = {
  fireProtection: PropTypes.object,
  isExpandable: PropTypes.bool,
  isTracking: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(FireDetectorSystemView);
